document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const i18n = window.ArteTimeI18n || {};
  const toggle = document.querySelector('[data-mobile-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const isOpen = nav.toggleAttribute('data-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      toggle.setAttribute('aria-label', isOpen ? (i18n.closeMenu || 'Close menu') : (i18n.openMenu || 'Open menu'));
    });
  }

  document.querySelectorAll('[data-submenu-toggle]').forEach((submenuToggle) => {
    submenuToggle.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const item = submenuToggle.closest('.nav__item--has-children');
      if (!item) return;
      const willOpen = !item.hasAttribute('data-submenu-open');
      document.querySelectorAll('.nav__item--has-children[data-submenu-open]').forEach((openItem) => {
        if (openItem !== item) {
          openItem.removeAttribute('data-submenu-open');
          const openToggle = openItem.querySelector('[data-submenu-toggle]');
          if (openToggle) openToggle.setAttribute('aria-expanded', 'false');
        }
      });
      item.toggleAttribute('data-submenu-open', willOpen);
      submenuToggle.setAttribute('aria-expanded', String(willOpen));
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.nav__item--has-children')) return;
    document.querySelectorAll('.nav__item--has-children[data-submenu-open]').forEach((item) => {
      item.removeAttribute('data-submenu-open');
      const itemToggle = item.querySelector('[data-submenu-toggle]');
      if (itemToggle) itemToggle.setAttribute('aria-expanded', 'false');
    });
  });

  const favoritesKey = 'artetime-favorites';
  const readFavorites = () => {
    try { return JSON.parse(localStorage.getItem(favoritesKey) || '[]').filter(Boolean); } catch (_) { return []; }
  };
  const writeFavorites = (favorites) => {
    try { localStorage.setItem(favoritesKey, JSON.stringify(favorites)); } catch (_) {}
  };
  const syncFavoriteUI = () => {
    const favorites = readFavorites();
    document.querySelectorAll('[data-wishlist-count]').forEach((count) => { count.textContent = String(favorites.length); });
    document.querySelectorAll('[data-favorite-toggle]').forEach((button) => {
      const active = favorites.includes(button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? (i18n.removeFavorite || 'Remove from wishlist') : (i18n.addFavorite || 'Add to wishlist'));
    });
  };
  const productCardMarkup = (item, currency, rootUrl) => {
    const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[character]));
    const money = new Intl.NumberFormat(document.documentElement.lang || 'it-IT', { style: 'currency', currency });
    const variant = item.variants && item.variants[0];
    const image = item.featured_image || (item.images && item.images[0]) || '';
    const productUrl = `${rootUrl}products/${encodeURIComponent(item.handle)}`;
    return `<article class="product-card"><button class="product-card__favorite" type="button" data-favorite-toggle data-product-handle="${escapeHtml(item.handle)}" aria-label="${escapeHtml(i18n.addFavorite || 'Add to wishlist')}" aria-pressed="false"><svg aria-hidden="true" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20.8 4.7a5.5 5.5 0 0 0-7.8 0L12 5.8l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.4 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z"/></svg></button><a href="${productUrl}"><div class="product-card__image">${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}</div><div class="product-card__info"><div class="product-card__vendor">${escapeHtml(item.vendor)}</div><h3 class="product-card__title">${escapeHtml(item.title)}</h3><div class="price"><span class="price__current">${money.format((variant ? variant.price : item.price) / 100)}</span></div></div></a></article>`;
  };
  const renderWishlistPage = async () => {
    const page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    const grid = page.querySelector('[data-wishlist-grid]');
    const empty = page.querySelector('[data-wishlist-empty]');
    const favorites = readFavorites();
    if (!favorites.length) {
      if (grid) grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    const rootUrl = page.dataset.rootUrl || '/';
    const currency = page.dataset.currency || 'EUR';
    const products = await Promise.all(favorites.map((handle) => fetch(`${rootUrl}products/${encodeURIComponent(handle)}.js`).then((response) => response.ok ? response.json() : null).catch(() => null)));
    if (grid) grid.innerHTML = products.filter(Boolean).map((item) => productCardMarkup(item, currency, rootUrl)).join('');
    syncFavoriteUI();
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-favorite-toggle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const handle = button.dataset.productHandle;
    let favorites = readFavorites();
    favorites = favorites.includes(handle) ? favorites.filter((item) => item !== handle) : [handle, ...favorites];
    writeFavorites(favorites.slice(0, 50));
    syncFavoriteUI();
    renderWishlistPage();
  });
  syncFavoriteUI();
  renderWishlistPage();

  let filterRequest;
  let priceFilterTimer;
  const setFiltersOpen = (open) => {
    const filterPanel = document.querySelector('[data-filter-panel]');
    const filterToggle = document.querySelector('[data-filter-toggle]');
    if (!filterPanel) return;
    filterPanel.toggleAttribute('data-open', open);
    document.body.toggleAttribute('data-filters-open', open);
    if (filterToggle) filterToggle.setAttribute('aria-expanded', String(open));
  };
  const updateCollection = async (form, requestedUrl) => {
    if (!form) return;
    if (filterRequest) filterRequest.abort();
    filterRequest = new AbortController();
    const url = requestedUrl
      ? new URL(requestedUrl, window.location.origin)
      : new URL(window.location.href);
    if (!requestedUrl) {
      const params = new URLSearchParams(new FormData(form));
      form.querySelectorAll('[data-manual-filter]:checked').forEach((input) => {
        (input.dataset.filterAliases || '').split('|').filter(Boolean).forEach((alias) => {
          if (!params.getAll(input.name).includes(alias)) params.append(input.name, alias);
        });
      });
      url.search = params.toString();
    }
    const layout = document.querySelector('.collection-layout');
    if (layout) layout.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(url.toString(), { signal: filterRequest.signal });
      if (!response.ok) throw new Error('Filter request failed');
      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextLayout = nextDocument.querySelector('.collection-layout');
      if (!nextLayout || !layout) throw new Error('Collection layout missing');
      layout.replaceWith(nextLayout);
      window.history.pushState({}, '', url);
      document.body.removeAttribute('data-filters-open');
      initCollectionFilters();
      syncFavoriteUI();
    } catch (error) {
      if (error.name !== 'AbortError') window.location.assign(url.toString());
    }
  };
  const initCollectionFilters = () => {
    const form = document.querySelector('[data-instant-filters]');
    const filterToggle = document.querySelector('[data-filter-toggle]');
    if (filterToggle) filterToggle.addEventListener('click', () => setFiltersOpen(true));
    document.querySelectorAll('[data-filter-close]').forEach((button) => button.addEventListener('click', () => setFiltersOpen(false)));
    if (!form) return;
    const currentParams = new URLSearchParams(window.location.search);
    form.querySelectorAll('[data-manual-filter]').forEach((input) => {
      input.checked = currentParams.getAll(input.name).includes(input.value);
    });
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      updateCollection(form);
    });
    form.querySelectorAll('input[type="checkbox"]').forEach((input) => {
      input.addEventListener('change', () => updateCollection(form, input.dataset.filterUrl));
    });
    form.querySelectorAll('.price-filter input').forEach((input) => {
      input.addEventListener('input', () => {
        window.clearTimeout(priceFilterTimer);
        priceFilterTimer = window.setTimeout(() => updateCollection(form), 600);
      });
    });
  };
  initCollectionFilters();
  window.addEventListener('popstate', () => window.location.reload());

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const form = select.closest('.buy-form');
      const productInfo = select.closest('.product-info');
      if (!form || !productInfo || !option) return;
      const available = option.dataset.available === 'true';
      const price = productInfo.querySelector('[data-variant-price]');
      const compare = productInfo.querySelector('[data-variant-compare]');
      const sku = productInfo.querySelector('[data-variant-sku]');
      const availability = productInfo.querySelector('[data-variant-availability]');
      const button = form.querySelector('[data-add-to-cart]');
      if (price) price.textContent = option.dataset.price || '';
      if (compare) {
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      }
      if (sku) sku.textContent = option.dataset.sku || '—';
      if (availability && (!availability.dataset.availabilityMode || availability.dataset.availabilityMode === 'default')) {
        availability.textContent = available ? (i18n.available || 'Available for shipping') : (i18n.unavailable || 'Currently unavailable');
        availability.classList.toggle('availability--sold', !available);
      }
      if (button) {
        button.disabled = !available;
        button.textContent = available ? (i18n.addToCart || 'Add to cart') : (i18n.soldOut || 'Unavailable');
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
    });
  });

  const recommendations = document.querySelector('[data-product-recommendations]');
  if (recommendations && recommendations.dataset.url) {
    fetch(recommendations.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const replacement = html.querySelector('[data-product-recommendations]');
        if (replacement && replacement.innerHTML.trim()) {
          recommendations.replaceWith(replacement);
          syncFavoriteUI();
        }
      })
      .catch(() => {});
  }

  document.querySelectorAll('.product-gallery__item img').forEach((image) => {
    const frame = image.closest('.product-gallery__item');
    if (!frame || window.matchMedia('(pointer: coarse)').matches) return;
    const lens = document.createElement('span');
    lens.className = 'product-image-zoom-lens';
    lens.setAttribute('aria-hidden', 'true');
    frame.appendChild(lens);
    frame.setAttribute('data-image-zoom-ready', '');
    const zoom = 2.15;
    const moveLens = (event) => {
      const frameRect = frame.getBoundingClientRect();
      const imageRect = image.getBoundingClientRect();
      const x = event.clientX - frameRect.left;
      const y = event.clientY - frameRect.top;
      const imageX = event.clientX - imageRect.left;
      const imageY = event.clientY - imageRect.top;
      if (imageX < 0 || imageY < 0 || imageX > imageRect.width || imageY > imageRect.height) {
        frame.removeAttribute('data-zoom-active');
        return;
      }
      const lensWidth = lens.offsetWidth || 154;
      const lensHeight = lens.offsetHeight || 154;
      lens.style.left = `${x}px`;
      lens.style.top = `${y}px`;
      lens.style.backgroundImage = `url("${image.currentSrc || image.src}")`;
      lens.style.backgroundSize = `${imageRect.width * zoom}px ${imageRect.height * zoom}px`;
      lens.style.backgroundPosition = `${-(imageX * zoom - lensWidth / 2)}px ${-(imageY * zoom - lensHeight / 2)}px`;
      frame.setAttribute('data-zoom-active', '');
    };
    frame.addEventListener('mousemove', moveLens);
    frame.addEventListener('mouseenter', moveLens);
    frame.addEventListener('mouseleave', () => frame.removeAttribute('data-zoom-active'));
  });

  document.querySelectorAll('[data-brand-carousel]').forEach((carousel) => {
    const viewport = carousel.querySelector('[data-brand-viewport]');
    const track = carousel.querySelector('[data-brand-track]');
    const previous = carousel.querySelector('[data-brand-prev]');
    const next = carousel.querySelector('[data-brand-next]');
    if (!viewport || !track) return;
    const step = () => Math.max(180, Math.min(viewport.clientWidth * .72, 760));
    const move = (direction) => viewport.scrollBy({ left: direction * step(), behavior: 'smooth' });
    let paused = false;
    let resumeTimer;
    let lastTime = 0;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const pause = () => { paused = true; };
    const resume = () => { paused = false; lastTime = performance.now(); };
    const pauseBriefly = () => {
      pause();
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(resume, 2200);
    };
    const manualMove = (direction) => { pauseBriefly(); move(direction); };
    if (previous) previous.addEventListener('click', () => manualMove(-1));
    if (next) next.addEventListener('click', () => manualMove(1));
    carousel.addEventListener('mouseenter', pause);
    carousel.addEventListener('mouseleave', resume);
    carousel.addEventListener('focusin', pause);
    carousel.addEventListener('focusout', resume);
    carousel.addEventListener('touchstart', pauseBriefly, { passive: true });
    const animate = (time) => {
      const loopWidth = track.scrollWidth / 2;
      if (!paused && !reducedMotion && loopWidth > viewport.clientWidth) {
        const elapsed = lastTime ? Math.min(time - lastTime, 50) : 0;
        viewport.scrollLeft -= elapsed * .034;
        if (viewport.scrollLeft <= 0) viewport.scrollLeft += loopWidth;
      }
      lastTime = time;
      window.requestAnimationFrame(animate);
    };
    window.requestAnimationFrame(() => {
      viewport.scrollLeft = track.scrollWidth / 2;
      window.requestAnimationFrame(animate);
    });
  });

  const recentSection = document.querySelector('[data-recently-viewed]');
  if (recentSection) {
    const storageKey = 'artetime-recent-products';
    const currentHandle = recentSection.dataset.currentHandle;
    const limit = Number(recentSection.dataset.limit || 4);
    const currency = recentSection.dataset.currency || 'EUR';
    const rootUrl = recentSection.dataset.rootUrl || '/';
    let history = [];
    try { history = JSON.parse(localStorage.getItem(storageKey) || '[]'); } catch (_) { history = []; }
    const previousHandles = history.filter((handle) => handle && handle !== currentHandle).slice(0, limit);
    const nextHistory = [currentHandle, ...history.filter((handle) => handle !== currentHandle)].slice(0, 12);
    try { localStorage.setItem(storageKey, JSON.stringify(nextHistory)); } catch (_) {}

    const grid = recentSection.querySelector('[data-recently-viewed-grid]');
    Promise.all(previousHandles.map((handle) => fetch(`${rootUrl}products/${encodeURIComponent(handle)}.js`).then((response) => response.ok ? response.json() : null).catch(() => null)))
      .then((products) => {
        const cards = products.filter(Boolean).map((item) => productCardMarkup(item, currency, rootUrl)).join('');
        if (grid && cards) {
          grid.innerHTML = cards;
          recentSection.hidden = false;
          syncFavoriteUI();
        }
      });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setFiltersOpen(false);
  });
  document.querySelectorAll('[data-advisor-open]').forEach((button) => {
    button.addEventListener('click', () => {
      const event = new CustomEvent('watch:advisor-open');
      window.dispatchEvent(event);
      const target = document.querySelector('#WatchAdvisor');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
});
